import React, { PropTypes, Component } from 'react';
import R from 'ramda';
import supplierWizardCompleteImage from '../../../../../../www/images/supplier-wizard-complete.svg';
import { FontIcon } from 'material-ui';
import { getStatusColor, getStatusIcon } from '../../../contractingUtils';
import BasicBox from './basicBox';

const propTypes = {
  viewingBy: React.PropTypes.string,
  locationId: React.PropTypes.string,
  files: React.PropTypes.array,
  state: React.PropTypes.string,
  isTourPlanUser: React.PropTypes.bool,
  supplierId: React.PropTypes.string,
  messageArray: React.PropTypes.array,
  emailStatus: React.PropTypes.number,
  viewingCompanyId: React.PropTypes.string,
  contractId: React.PropTypes.string,
  changeContractStateTo: React.PropTypes.func,
  resendContract: React.PropTypes.func,
  userNameOrEmail: React.PropTypes.string,
  buyerChecked: React.PropTypes.bool,
  viewedBy: React.PropTypes.array,
  from: React.PropTypes.object,
  rateContainer: React.PropTypes.object,
  push: React.PropTypes.func,
};

class BuyerContractProgressBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hovering: false,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }

  setHoveringFalse = () => {
    this.setState({ hovering: false });
  };

  setHoveringTrue = () => {
    this.setState({ hovering: true });
  };

  _handleAcceptContract = () => {
    window.dataLayer.push({
      event: 'TRACK_EVENT',
      ev: {
        category: 'Contract Top Bar Clicked',
        action: 'accepted',
      },
    });
    this.props.changeContractStateTo('accepted', { [this.props.contractId]: this.props.contractId })
  };

  _handleLoadingContract = () => {
    window.dataLayer.push({
      event: 'TRACK_EVENT',
      ev: {
        category: 'Contract Top Bar Clicked',
        action: 'loading',
      },
    });
    this.props.changeContractStateTo('loading', { [this.props.contractId]: this.props.contractId });
  }

  _handleLoadContract = () => {
    window.dataLayer.push({
      event: 'TRACK_EVENT',
      ev: {
        category: 'Contract Top Bar Clicked',
        action: 'loaded',
      },
    });
    this.props.changeContractStateTo('loaded', { [this.props.contractId]: this.props.contractId });
  }

  _handleRejectContract = () => this.props.changeContractStateTo('rejected', { [this.props.contractId]: this.props.contractId });

  _markContractAsReceived = () => this.props.changeContractStateTo('received externally', { [this.props.contractId]: this.props.contractId });
  _markContractAsNOTReceived = () => this.props.changeContractStateTo('sent', { [this.props.contractId]: this.props.contractId });
  render() {
    const {
      locationId,
      state,
      contractId,
      messageArray,
      buyerChecked,
      emailStatus,
      userNameOrEmail,
      from,
      rateContainer,
      buyerCreatedFrom,
      push,
    } = this.props;
    if (!messageArray) return <div/>;
    const selfLoaded = Boolean(from && from.email.indexOf('dl+') > -1);
    const firstMsg = R.last(messageArray) || {};
    const initiatedByBuyer = firstMsg.isSender;
    const loadedLogs = messageArray.filter(msg =>
      R.pathOr([], ['bodyJson', 'contracts'], msg).some(obj => obj.currentVersionId === contractId && obj.statusChanged === 'loaded'));
    const loadingLogs = messageArray.filter(msg =>
      R.pathOr([], ['bodyJson', 'contracts'], msg).some(obj => obj.currentVersionId === contractId && obj.statusChanged === 'loading'));
    const acceptedLogs = messageArray.filter(msg =>
      R.pathOr([], ['bodyJson', 'contracts'], msg).some(obj => obj.currentVersionId === contractId && obj.statusChanged === 'accepted'));
    const rejectedLogs = messageArray.filter(msg =>
      R.pathOr([], ['bodyJson', 'contracts'], msg).some(obj => obj.currentVersionId === contractId && obj.statusChanged === 'rejected'));
    const hovering = this.state.hovering;
    const isSent = initiatedByBuyer;
    const isBounced = Boolean(initiatedByBuyer && emailStatus === 1);
    const openEvent = initiatedByBuyer
      && firstMsg.events
      && R.values(firstMsg.events).length
      && R.values(firstMsg.events).find(obj => obj.event === 'open');
    const deliverEvent = initiatedByBuyer
      && firstMsg.events
      && R.values(firstMsg.events).length
      && R.values(firstMsg.events).find(obj => obj.event === 'delivered');
    const isDelivered = initiatedByBuyer && (emailStatus > 1 || Boolean(deliverEvent));
    const isOpened = Boolean(openEvent);
    const ratesReceived = Boolean(locationId) || buyerChecked;
    const isRejected = state === 'rejected';
    const isAccepted = state === 'accepted';
    const isLoaded = state === 'loaded';
    const isLoading = state === 'loading';
    const valueMap = {
      loaded: 11,
      loading: 10,
      accepted: 9,
      rejected: 8,
      ratesReceived: 7,
      opened: 6,
      delivered: 5,
      bounced: 4,
      sent: 3,
    };
    const currentState = (() => {
      if (isLoaded) return 11;
      if (isLoading) return 10;
      if (isAccepted) return 9;
      if (isRejected) return 8;
      if (ratesReceived) return 7;
      if (isOpened) return 6;
      if (isDelivered) return 5;
      if (isBounced) return 4;
      if (isSent) return 3;
    })();
    return (
      <div className="flex-tc-sb" style={{ position: 'relative' }} onMouseEnter={this.setHoveringTrue} onMouseLeave={this.setHoveringFalse}>
        <BasicBox
          content={(() => {
            if (selfLoaded) {
              if (buyerCreatedFrom) return 'Created from Supplier-Sent Contract';
              return 'Created from Workspace';
            }
            return 'Received from Supplier';
          })()}
          buttonLabel={(() => {
            if (selfLoaded) {
              if (buyerCreatedFrom) return 'Go To Contract';
              return 'Go To Workspace';
            }
          })()}
          style={{ flex: 'auto' }}
          hovering={Boolean(selfLoaded && hovering)}
          onClick={() => {
            if (selfLoaded && rateContainer) {
              if (buyerCreatedFrom) return push(`/contracting/contract/${buyerCreatedFrom.split('|')[0]}/policies`);
              return push(`/contracting/contract/${rateContainer.id}/policies`);
            }
          }}
          actorName={(firstMsg.creatorMeta || {}).name || firstMsg.creatorEmail}
          ts={selfLoaded ? firstMsg.createdAt : null}
          done
        />
        {
          // (isBounced) && (
          //   <BasicBox
          //     content="Bounced"
          //     style={{ flex: 'auto', color: '#e53935', width: '20%', fontWeight: 'bold' }}
          //     tooltip="Click to resend this request to a new email address"
          //     onClick={this.props.resendContract}
          //     noArrow
          //     isSupplierAction
          //     done
          //     ts={firstMsg.createdAt}
          //   />
          // )
        }
        {/* <BasicBox
          content="Delivered"
          style={initiatedByBuyer ? { flex: 'auto' } : { width: '11%' }}
          inactive={!initiatedByBuyer}
          ts={deliverEvent ? deliverEvent.timestamp : null}
          actorName={deliverEvent ? deliverEvent.email : null}
          done={isDelivered || currentState > valueMap.delivered}
          isSupplierAction
        />
        <BasicBox
          content="Opened"
          style={initiatedByBuyer ? { flex: 'auto' } : { width: '10%' }}
          inactive={!initiatedByBuyer}
          ts={isOpened ? openEvent.timestamp : null}
          actorName={isOpened ? openEvent.email : null}
          done={Boolean(isOpened || currentState > valueMap.opened)}
          isSupplierAction
        /> */}
        {/* <BasicBox
          content={
            currentState >= valueMap.ratesReceived ?
            (<div className="flex-center" style={{ color: getStatusColor('received') }}>
              <FontIcon className={getStatusIcon('received')} color={getStatusColor('received')} />
              &nbsp;Rates Received
            </div>) : 'Rates Received'
          }
          style={{ flex: 'auto' }}
          hovering={hovering}
          done={currentState >= valueMap.ratesReceived}
          tooltip={(currentState < valueMap.ratesReceived) && 'Click to mark this contract as received'}
          onClick={(state !== 'pending' || !ratesReceived) && this._markContractAsReceived}
          isSupplierAction
          buttonLabel="Mark as Received"
          ts={(() => {
            if (locationId) {
              return (messageArray.find(obj => obj.companyId === supplierId) || {})
                .createdAt;
            }
            if (ratesReceived && files && files.length) return files[0].createdAt;
          })()}
        /> */}
        {
          (isRejected) && (
            <BasicBox
              content={
                <div className="flex-center" style={{ color: getStatusColor('rejected') }}>
                  <FontIcon className={getStatusIcon('rejected')} color={getStatusColor('rejected')} />
                  &nbsp;Rejected
                </div>
              }
              style={{ color: '#e53935', flex: 'auto', width: '20%', fontWeight: 'bold' }}
              noArrow
              done
              actorName={(() => {
                if (rejectedLogs && rejectedLogs.length) {
                  return R.pathOr('', ['creatorMeta', 'name'], R.last(rejectedLogs))
                    || R.last(rejectedLogs).creatorEmail;
                }
                return userNameOrEmail;
              })()}
              ts={(() => {
                if (rejectedLogs && rejectedLogs.length) return R.last(rejectedLogs).createdAt;
                return new Date().toISOString();
              })()}
            />
          )
        }
        <BasicBox
          content={
            currentState >= valueMap.accepted ?
            (<div className="flex-center" style={{ color: getStatusColor('accepted') }}>
              <FontIcon className={getStatusIcon('accepted')} color={getStatusColor('accepted')} />
              &nbsp;Accepted
            </div>) : 'Accepted'
          }
          style={{ flex: 'auto' }}
          hovering={hovering}
          tooltip={currentState < 8 && 'Click to accept this contract'}
          onClick={state !== 'accepted' && this._handleAcceptContract}
          done={currentState >= valueMap.accepted}
          buttonLabel="Mark as Accepted"
          actorName={(() => {
            if (state === 'accepted' || state === 'loading' || state === 'loaded') {
              if (acceptedLogs && acceptedLogs.length) {
                return R.pathOr('', ['creatorMeta', 'name'], R.last(acceptedLogs))
                  || R.pathOr('', ['creatorMeta', 'realActorEmail'], R.last(acceptedLogs)) || R.last(acceptedLogs).creatorEmail;
              }
              if (loadingLogs && loadingLogs.length) {
                return R.pathOr('', ['creatorMeta', 'name'], R.last(loadingLogs))
                  || R.last(loadingLogs).creatorEmail;
              }
              if (loadedLogs && loadedLogs.length) {
                return R.pathOr('', ['creatorMeta', 'name'], R.last(loadedLogs))
                  || R.last(loadedLogs).creatorEmail;
              }
              return userNameOrEmail;
            }
          })()}
          ts={(() => {
            if (state === 'accepted' || state === 'loading' || state === 'loaded') {
              if (acceptedLogs && acceptedLogs.length) return R.last(acceptedLogs).createdAt;
              if (loadingLogs && loadingLogs.length) return R.last(loadingLogs).createdAt;
              if (loadedLogs && loadedLogs.length) return R.last(loadedLogs).createdAt;
              return new Date().toISOString();
            }
          })()}
        />
        <BasicBox
          content={
            currentState >= 10 ?
              (<div className="flex-center" style={{ color: getStatusColor('loading') }}>
              <FontIcon className={getStatusIcon('loading')} color={getStatusColor('loading')} />
              &nbsp;Loading
            </div>) : 'Loading'
          }
          style={{ flex: 'auto' }}
          hovering={hovering}
          tooltip={currentState < 10 && state !== 'rejected' && 'Click to mark this contract as loading'}
          onClick={state !== 'rejected' && this._handleLoadingContract}
          done={currentState >= 10}
          buttonLabel="Mark as Loading"
          actorName={(() => {
            if (state === 'loading' || state === 'loaded') {
              if (loadingLogs && loadingLogs.length) {
                return R.pathOr('', ['creatorMeta', 'name'], R.last(loadingLogs))
                  || R.last(loadingLogs).creatorEmail;
              }
              if (loadedLogs && loadedLogs.length) {
                return R.pathOr('', ['creatorMeta', 'name'], R.last(loadedLogs))
                  || R.last(loadedLogs).creatorEmail;
              }
              return userNameOrEmail;
            }
          })()}
          ts={(() => {
            if (state === 'loading' || state === 'loaded') {
              if (loadingLogs && loadingLogs.length) return R.last(loadingLogs).createdAt;
              if (loadedLogs && loadedLogs.length) return R.last(loadedLogs).createdAt;
              return new Date().toISOString();
            }
          })()}
        />
        <BasicBox
          content={isLoaded ? (<span className="flex-tc-sb"><img src={supplierWizardCompleteImage} style={{ height: '24px' }} /> Loaded <img src={supplierWizardCompleteImage} style={{ height: '24px' }} /></span>) : 'Loaded'}
          hovering={hovering}
          tooltip={currentState < 11 && state !== 'rejected' && 'Click to mark this contract as loaded'}
          onClick={state !== 'loaded' && this._handleLoadContract}
          style={{ flex: 'auto', borderRight: '1px solid #e0e0e0' }}
          done={isLoaded}
          buttonLabel="Mark as Loaded"
          noArrow
          actorName={(() => {
            if (state === 'loaded') {
              if (loadedLogs && loadedLogs.length) {
                return R.pathOr('', ['creatorMeta', 'name'], R.last(loadedLogs))
                  || R.last(loadedLogs).creatorEmail;
              }
              return userNameOrEmail;
            }
          })()}
          ts={(() => {
            if (state === 'loaded') {
              if (loadedLogs && loadedLogs.length) return R.last(loadedLogs).createdAt;
              return new Date().toISOString();
            }
          })()}
        />
        {
          !initiatedByBuyer && (
            <div
              className="flag-across-progress-bar"
              style={{ backgroundColor: '#546e7a', width: '32%', position: 'absolute', top: '74px' }}
            >
              Contract was inititated by Supplier
            </div>
          )
        }
      </div>
    );
  }
}

BuyerContractProgressBar.propTypes = propTypes;

export default BuyerContractProgressBar;




// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-container/progressIndicatorBar/forBuyer.jsx